import { useState, useEffect } from "react";
import { X, Loader2 } from "lucide-react";
import useAxiosAdmin from "../../lib/axiosAdmin";
import StaffInfoTab from "./Tabs/InfoTab";
import StaffWorkTimeTab from "./Tabs/WorkTimeTab";
import StaffHolidayTab from "./Tabs/HolidayTab";
import StaffServicesTab from "./Tabs/ServicesTab";
import { SET_SHOULD_UPDATE_ADMIN_USERS } from "../../../../redux/action/admin/users/type";
import { useDispatch } from "react-redux";
// import StaffWorkTimeTab from "./tabs/StaffWorkTimeTab";
// import StaffHolidayTab from "./tabs/StaffHolidayTab";
// import StaffServicesTab from "./tabs/StaffServicesTab";

const StaffModal = ({ onClose, onSuccess, editStaff }) => {
  const axiosAdmin = useAxiosAdmin();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const dispatch = useDispatch()

  const [formData, setFormData] = useState({
    information: {
      firstName: "",
      lastName: "ساراد",
      displayName: "",
      phone: "",
    },
    services: [],
    holidays: [],
    workTime: {
      shanbeh: [],
      yekshanbeh: [],
      doshanbeh: [],
      seshanbeh: [],
      chaharshanbeh: [],
      panjshanbeh: [],
      jomeh: [],
    },
  });

   useEffect(() => {
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

  // دریافت اطلاعات کارمند برای ویرایش
  useEffect(() => {
    const fetchStaffData = async () => {
      if (!editStaff?._id) return;

      try {
        setLoading(true);
        const res = await axiosAdmin.get(`/api/admin/staff/${editStaff._id}`);
        
        if (res.data.staff) {
          setFormData({
            information: res.data.staff.information || {
              firstName: "",
              lastName: "ساراد",
              displayName: "",
              phone: "",
            },
            services: res.data.staff.services || [],
            holidays: res.data.staff.holidays || [],
            workTime: res.data.staff.workTime || {
              shanbeh: [],
              yekshanbeh: [],
              doshanbeh: [],
              seshanbeh: [],
              chaharshanbeh: [],
              panjshanbeh: [],
              jomeh: [],
            },
          });
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات کارمند:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStaffData();
  }, [editStaff]);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);

      if (editStaff?._id) {
        await axiosAdmin.put(`/api/admin/staff/${editStaff._id}`, formData);
      } else {
        await axiosAdmin.post(`/api/admin/staff`, formData);
      }

      onSuccess();
      onClose();

      dispatch({
        type: SET_SHOULD_UPDATE_ADMIN_USERS,
        payload: true,
      })    

    } catch (error) {
      console.error("خطا در ذخیره کارمند:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const tabs = [
    { id: 0, label: "اطلاعات", icon: "👤" },
    { id: 1, label: "تایم کاری", icon: "🕐" },
    { id: 2, label: "تعطیلات", icon: "📅" },
    { id: 3, label: "خدمات", icon: "💼" },
  ];

  return (
    <div className="fixed  inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[1000] p-4">
      <div className="bg-white w-full max-w-5xl rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
        
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <span className="text-2xl">
                {editStaff ? "✏️" : "➕"}
              </span>
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">
                {editStaff ? "ویرایش کارمند" : "افزودن کارمند جدید"}
              </h2>
              <p className="text-purple-100 text-sm mt-0.5">
                اطلاعات کارمند را با دقت وارد کنید
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors group"
          >
            <X className="w-5 h-5 text-white group-hover:rotate-90 transition-transform duration-300" />
          </button>
        </div>

        {/* Tabs Navigation */}
        <div className="bg-slate-50 border-b border-slate-200 px-6">
          <div className="flex gap-1 overflow-x-auto scrollbar-hide">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                disabled={loading}
                className={`
                  relative px-5 py-3.5 text-sm font-medium whitespace-nowrap transition-all duration-300
                  ${
                    activeTab === tab.id
                      ? "text-purple-700"
                      : "text-slate-600 hover:text-slate-900"
                  }
                  ${loading ? "opacity-50 cursor-not-allowed" : ""}
                `}
              >
                <span className="flex items-center gap-2">
                  <span className="text-base">{tab.icon}</span>
                  {tab.label}
                </span>
                
                {activeTab === tab.id && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-purple-600 to-purple-700 rounded-t-full" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-6 max-h-[calc(100vh-280px)] overflow-y-auto">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-20">
              <Loader2 className="w-10 h-10 text-purple-500 animate-spin mb-3" />
              <p className="text-slate-500 text-sm">در حال بارگذاری اطلاعات...</p>
            </div>
          ) : (
            <>
              {activeTab === 0 && (
                <StaffInfoTab formData={formData} setFormData={setFormData} />
              )}

              {activeTab === 1 && (
                <StaffWorkTimeTab formData={formData} setFormData={setFormData} /> // ✅ اضافه شد
              )}

              {activeTab === 2 && (
                <StaffHolidayTab formData={formData} setFormData={setFormData} />
                )}

              {activeTab === 3 && (
                <StaffServicesTab 
                  formData={formData} 
                  setFormData={setFormData} 
                  editMode={editStaff?._id ? true : false}
                  staffId={editStaff?._id} 
                />
              )}
            </>
          )}
        </div>

        {/* Footer Actions */}
        <div className="bg-slate-50 border-t border-slate-200 px-6 py-4 flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            disabled={submitting}
            className="px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            لغو
          </button>
          
          <button
            onClick={handleSubmit}
            disabled={submitting || loading}
            className="px-6 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 rounded-lg shadow-md shadow-purple-500/25 hover:shadow-lg hover:shadow-purple-500/30 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {submitting ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                در حال ذخیره...
              </>
            ) : (
              <>
                <span>💾</span>
                ذخیره اطلاعات
              </>
            )}
          </button>
        </div>

      </div>
    </div>
  );
};

export default StaffModal;